import { Component } from "@angular/core";

@Component({
	selector: "caass-groups",
	templateUrl: "./groups.component.html",
})
export class GroupsComponent {}
